module.exports = __webpack_public_path__ + "img/Menu-07.fa23071c.png";